import { c as _c } from "react/compiler-runtime";
import { AnalyticsSkuViewed } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import type { ReactElement } from 'react';
import { useReviewContext } from '../../Context';
export function SidebarProductCardImpressionWrapper(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const {
    marketplaceEntity: t1
  } = useReviewContext();
  const {
    id,
    monetizable,
    name,
    displayName,
    institution: t2,
    product: t3
  } = t1;
  const {
    id: institutionId,
    name: institutionName
  } = t2;
  const {
    id: productId,
    name: productName
  } = t3;
  let t4;
  if ($[0] !== children || $[1] !== displayName || $[2] !== id || $[3] !== institutionId || $[4] !== institutionName || $[5] !== monetizable || $[6] !== name || $[7] !== productId || $[8] !== productName) {
    t4 = <AnalyticsSkuViewed id={id} impressionSection="review_product_card_sticky" impressionPosition={0} institutionId={institutionId} institutionName={institutionName} monetizable={monetizable} name={name} offerId={id} offerName={displayName} productId={productId} productName={productName}>{children}</AnalyticsSkuViewed>;
    $[0] = children;
    $[1] = displayName;
    $[2] = id;
    $[3] = institutionId;
    $[4] = institutionName;
    $[5] = monetizable;
    $[6] = name;
    $[7] = productId;
    $[8] = productName;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}